module.exports = __webpack_public_path__ + "00a495863252fb693b9dc2fb90f266da.svg";